module.exports = __webpack_public_path__ + "media/le-reshop/background-97242b35.png";